import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import utc from "dayjs/plugin/utc";
import type { App } from "vue";

export function setupDayjs(app: App) {
    dayjs.extend(relativeTime);
    dayjs.extend(utc);

    app.provide("$dayjs", dayjs);
    // Register utility functions globally
    app.config.globalProperties.$dayjs = dayjs;
}